<template>
  <div class="statistics-container">
    <PageHeader title="Statisztikák" subtitle="Részletes jelentések és elemzések">
      <template #icon>
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M3 3v18h18"/>
          <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"/>
        </svg>
      </template>
    </PageHeader>

    <div class="statistics-grid">
      <!-- Left side content area -->
      <div class="statistics-content">
        <div class="statistics-sections">

          <!-- Payment Statistics Section -->
          <div class="statistics-section">
            <div class="section-header">
              <div class="section-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                </svg>
              </div>
              <h2>Fizetési Statisztikák</h2>
            </div>
            <div class="statistics-cards">
              <div class="statistics-card">
                <router-link to="/statistics/payments" class="statistics-link" @click="showContent('payments')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                    </svg>
                  </div>
                  <div class="card-content">
                    <h3>Fizetési Statisztikák</h3>
                    <p>Fizetések összesítése csoportok, tanárok és gyerekek szerint</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <!-- Monthly Statistics Section -->
          <div class="statistics-section">
            <div class="section-header">
              <div class="section-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/>
                  <line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
              </div>
              <h2>Havi bontások</h2>
            </div>
            <div class="statistics-cards">
              <div class="statistics-card">
                <router-link to="/statistics/groupmonth" class="statistics-link" @click="showContent('groupmonth')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                      <circle cx="9" cy="7" r="4"/>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                    </svg>
                  </div>
                  <div class="card-content">
                     <h3>Csoportos havi bontás</h3>
                    <p>Havi csoportonkénti fogyás</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>

              <div class="statistics-card">
                <router-link to="/statistics/allmonth" class="statistics-link" @click="showContent('allmonth')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M3 3v18h18"/>
                      <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"/>
                    </svg>
                  </div>
                  <div class="card-content">
                    <h3>Teljes havi fogyás</h3>
                    <p>Havi teljes fogyás</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>

              <div class="statistics-card">
                <router-link to="/statistics/norespmonth" class="statistics-link" @click="showContent('norespmonth')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"/>
                      <line x1="15" y1="9" x2="9" y2="15"/>
                      <line x1="9" y1="9" x2="15" y2="15"/>
                    </svg>
                  </div>
                  <div class="card-content">
                    <h3>Időben nem visszaigazolt havi fogyás</h3>
                    <p>Időben nem visszaigazolt havi fogyás</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <!-- Weekly Statistics Section -->
          <div class="statistics-section">
            <div class="section-header">
              <div class="section-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/>
                  <line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
              </div>
              <h2>Heti bontások</h2>
            </div>
            <div class="statistics-cards">
              <div class="statistics-card">
                <router-link to="/statistics/groupweek" class="statistics-link" @click="showContent('groupweek')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                      <circle cx="9" cy="7" r="4"/>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                    </svg>
                  </div>
                  <div class="card-content">
                    <h3>Csoportos heti fogyás</h3>
                    <p>Heti csoportonkénti fogyás</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>

              <div class="statistics-card">
                <router-link to="/statistics/allweek" class="statistics-link" @click="showContent('allweek')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M3 3v18h18"/>
                      <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"/>
                    </svg>
                  </div>
                  <div class="card-content">
                    <h3>Teljes heti fogyás</h3>
                    <p>Heti teljes fogyás</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>

              <div class="statistics-card">
                <router-link to="/statistics/norespweek" class="statistics-link" @click="showContent('norespweek')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"/>
                      <line x1="15" y1="9" x2="9" y2="15"/>
                      <line x1="9" y1="9" x2="15" y2="15"/>
                    </svg>
                  </div>
                  <div class="card-content">
                    <h3>Időben nem visszaigazolt heti fogyás</h3>
                    <p>Időben nem visszaigazolt heti fogyás</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Right side calendar -->
      <div class="calendar-sidebar">
        <calendar-item />
      </div>
    </div>

    <!-- Overlay when floating content is open -->
    <div v-if="activeContent" class="overlay" @click="closeContent"></div>

    <!-- Floating content area -->
    <div v-if="activeContent" class="floating-content">
      <div class="floating-header">
        <h2>Statisztikák</h2>
        <button class="close-btn" @click="closeContent">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
      <div class="floating-body">
        <router-view />
      </div>
    </div>
  </div>
</template>
  
  <script>
import CalendarItem from './CalendarItem.vue';
import PageHeader from './shared/PageHeader.vue';

export default {
  components: {
    CalendarItem,
    PageHeader
  },
    data() {
      return {
        activeContent: null
      };
    },
    methods: {
      showContent(content) {
        this.activeContent = content; // Set the active content based on the clicked card
      },
      closeContent() {
        this.activeContent = null; // Close the floating content when X is clicked
      }
    }
  };
  </script>
  
<style scoped>
.statistics-container {
  min-height: 100vh;
  padding: 2rem 1rem;
  max-width: 1400px;
  margin: 0 auto;
}

.statistics-grid {
  display: grid;
  grid-template-columns: 1fr 350px;
  gap: 2rem;
  align-items: start;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

.statistics-content {
  min-height: 500px;
}

.statistics-sections {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.statistics-section {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow);
  border: 1px solid var(--color-border);
  overflow: hidden;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 2rem;
  background: var(--color-background-mute);
  border-bottom: 1px solid var(--color-border);
}

.section-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  border-radius: 8px;
  color: white;
  flex-shrink: 0;
}

.section-header h2 {
  color: var(--color-heading);
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.statistics-cards {
  padding: 1.5rem;
  display: grid;
  gap: 1rem;
}

.statistics-card {
  background: var(--card-bg);
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--color-border);
  transition: all 0.3s ease;
  overflow: hidden;
}

.statistics-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
  border-color: var(--primary-blue);
}

.statistics-link {
  display: flex;
  align-items: center;
  padding: 1.25rem;
  text-decoration: none;
  color: inherit;
  gap: 1rem;
  transition: all 0.3s ease;
}

.statistics-link:hover {
  text-decoration: none;
  color: inherit;
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  border-radius: 10px;
  color: white;
  flex-shrink: 0;
  box-shadow: var(--shadow-sm);
}

.card-content {
  flex: 1;
}

.card-content h3 {
  color: var(--color-heading);
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
}

.card-content p {
  color: var(--color-text-muted);
  font-size: 0.875rem;
  margin: 0;
  line-height: 1.4;
}

.card-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  background: var(--color-background-mute);
  border-radius: 50%;
  color: var(--primary-blue);
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.statistics-card:hover .card-arrow {
  background: var(--primary-blue);
  color: white;
  transform: translateX(4px);
}

.calendar-sidebar {
  position: sticky;
  top: 2rem;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1040;
  backdrop-filter: blur(4px);
  transition: all 0.3s ease;
}

.floating-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 1000px;
  max-height: 80vh;
  background: var(--card-bg);
  border-radius: 20px;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--color-border);
  z-index: 1050;
  overflow: hidden;
  transition: all 0.3s ease;
}

.floating-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background: var(--color-background-mute);
  border-bottom: 1px solid var(--color-border);
}

.floating-header h2 {
  color: var(--color-heading);
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: var(--color-background-mute);
  border: 1px solid var(--color-border);
  border-radius: 50%;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: var(--error);
  color: white;
  border-color: var(--error);
  transform: scale(1.1);
}

.floating-body {
  padding: 2rem;
  max-height: calc(80vh - 80px);
  overflow-y: auto;
}

/* Responsive design */
@media (max-width: 1024px) {
  .statistics-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .calendar-sidebar {
    position: static;
    order: -1;
  }
}

@media (max-width: 768px) {
  .statistics-container {
    padding: 1rem 0.75rem;
  }
  
  .statistics-header {
    padding: 1.5rem;
    border-radius: 12px;
    margin-bottom: 2rem;
  }
  
  .header-icon {
    width: 64px;
    height: 64px;
  }
  
  .statistics-header h1 {
    font-size: 2rem;
  }
  
  .statistics-header p {
    font-size: 1rem;
  }
  
  .section-header {
    padding: 1rem 1.5rem;
  }
  
  .section-header h2 {
    font-size: 1.25rem;
  }
  
  .statistics-cards {
    padding: 1rem;
  }
  
  .statistics-link {
    padding: 1rem;
    gap: 0.75rem;
  }
  
  .card-icon {
    width: 45px;
    height: 45px;
  }
  
  .card-content h3 {
    font-size: 1rem;
  }
  
  .card-content p {
    font-size: 0.8rem;
  }
  
  .floating-content {
    width: 95%;
    max-height: 85vh;
  }
  
  .floating-header {
    padding: 1rem 1.5rem;
  }
  
  .floating-header h2 {
    font-size: 1.25rem;
  }
  
  .floating-body {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .statistics-container {
    padding: 0.75rem 0.5rem;
  }
  
  .statistics-header {
    padding: 1.25rem;
    border-radius: 10px;
  }
  
  .header-icon {
    width: 56px;
    height: 56px;
  }
  
  .statistics-header h1 {
    font-size: 1.75rem;
  }
  
  .statistics-header p {
    font-size: 0.9rem;
  }
  
  .section-header {
    padding: 0.75rem 1rem;
  }
  
  .section-header h2 {
    font-size: 1.125rem;
  }
  
  .statistics-link {
    padding: 0.75rem;
    gap: 0.5rem;
  }
  
  .card-icon {
    width: 40px;
    height: 40px;
  }
  
  .card-content h3 {
    font-size: 0.9rem;
  }
  
  .card-content p {
    font-size: 0.75rem;
  }
  
  .card-arrow {
    width: 30px;
    height: 30px;
  }
  
  .floating-content {
    width: 98%;
    max-height: 90vh;
    border-radius: 16px;
  }
  
  .floating-header {
    padding: 0.75rem 1rem;
  }
  
  .floating-header h2 {
    font-size: 1.125rem;
  }
  
  .floating-body {
    padding: 1rem;
  }
}
</style>
  